class Card1Controller {
    constructor (Color) {
        this.name = 'card1'
        this.limitDefaultValue = 260
        this.limitDefaultValueMobile = 200
        this.Color = Color
    }

    $onInit () {
        this.setColor()

        this.setFields()
    }

    setColor () {
        const colors = this.Color.getColors(this.data.cardType, this.data.cardGroup)

        this.color1 = colors[0]
        this.color2 = colors[1]
        this.color3 = colors[2]
        this.color4 = colors[3]
    }

    setFields () {
        // this.data.owner.avatarUrl = this.data.owner.avatarUrl || '/assets/images/user.jpg'
        this.limitForText = this.limitDefaultValue
        this.limitForTextMobile = this.limitDefaultValueMobile
    }

    readMore (type) {
        if (type === 'web') {
            this.limitForText = this.data.caption.length
            this.readMoreMode = true
        } else if (type === 'mobile') {
            this.limitForTextMobile = this.data.caption.length
            this.readMoreMode = true
        }

    }

    readLess (type) {
        if (type === 'web') {
            this.limitForText = this.limitDefaultValue
            this.readMoreMode = false
        } else if (type === 'mobile') {
            this.limitForTextMobile = this.limitDefaultValueMobile
            this.readMoreMode = false
        }
    }

}

Card1Controller.$inject = ['Color']

export default Card1Controller



// WEBPACK FOOTER //
// ./client/app/components/home/sharedmoments/card1/card1.controller.js